import type { AllRouteEndpoints } from "../routeTypes";

export const alloysZendeskSunshineAppGroupId = "/alloys/zendesk-sunshine/:app_group_id";

export const postAlloysZendeskSunshineAppGroupIdCacheKeys: AllRouteEndpoints[] = [alloysZendeskSunshineAppGroupId];
